import React from "react"
import { Link } from "gatsby"
import BackToTop from "./backtotop"
import valinorLogo from "../images/averitas-logo.png"

const Footer = (props) => {

  const { pageType } = props;

  const sitemapUrl = pageType === 'hcp' ? '/hcp/sitemap/' : '/sitemap/';
  const privacyURL = pageType === 'hcp' ? '/hcp/privacy-policy/' : '/privacy-policy/';
  const contactURL = pageType === 'hcp' ? '/hcp/contact/' : '/contact/';
  const termsURL = pageType === 'hcp' ? '/hcp/terms-of-use/' : '/terms-of-use/';

  return (
    <footer>
      <BackToTop pageType={pageType} />
      <div className="container">
        <div className="footer-top">
          <div className="footer-links">
            <div className="footer-link">
              <Link to={contactURL} id={`footer-${pageType}-contact`}>Contact Us</Link>
            </div>
            <div className="footer-link">
              <a href="https://www.averitaspharma.com/privacy-statement/" target="_blank" rel="noopener noreferrer" id={`footer-${pageType}-privacy-policy`}>Privacy Policy</a>
            </div>
            <div className="footer-link">
              <a href="https://www.averitaspharma.com/terms-of-use/" target="_blank" rel="noopener noreferrer" id={`footer-${pageType}-terms`}>Terms of Use</a>
            </div>
            <div className="footer-link">
              <Link to={sitemapUrl} id={`footer-${pageType}-sitemap`}>Site Map</Link>
            </div>
            <div className="footer-link">
              <a href="/pdf/MovantikPrescribingInformation.pdf" target="_blank" id={`footer-${pageType}-pi`}>Prescribing Information</a>
            </div>
            <div className="footer-link">
              <a href="/pdf/MovantikMedicationGuide.pdf" target="_blank" id={`footer-${pageType}-medguide`}>Medication Guide</a>
            </div>
          </div>
          <a href="https://www.averitaspharma.com/" target="_blank" rel="noopener noreferrer" id={`footer-logo`}>
            <img src={valinorLogo} className="footer-logo" alt="Averitas Pharma, Inc. logo" />
          </a>
        </div>
        <div className="footer-bottom">
          <p>MOVANTIK is a registered trademark of Averitas Pharma, Inc.</p>
          <p>&copy; 2026 Averitas Pharma, Inc. <span className="nowrap">MOVA-09-25-0001 v2.0 September 2026</span></p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
